import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { CheckboxGroup, CheckboxGroupOption } from 'shared/ui/CheckboxGroup';
import { GridFormField } from 'shared/ui/FormComponents/FormField';
import { Flex, Label } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { Field, type FieldProps } from 'formik';

type Props<T extends number | string> = {
  align: 'vertical' | 'horizontal';
  name: string;
  multiply?: boolean;
  options: CheckboxGroupOption<T>[];
  label?: string;
  labelGap?: number;
  comment?: string;
  customLabel?: string;
};

export const FormCheckboxGroup = <T extends number | string>({
  align,
  name,
  multiply,
  options,
  label,
  labelGap,
  comment,
  customLabel,
}: Props<T>) => (
  <Field name={name}>
    {({ form, field, meta }: FieldProps) =>
      !customLabel ? (
        <GridFormField label={label} height='90%'>
          <Box mt={10}>
            <CheckboxGroup
              labelGap={labelGap}
              align={align}
              onChange={(value) => {
                form.setFieldValue(name, value);
              }}
              value={field.value}
              errorMessage={(meta.touched && meta.error) || ''}
              multiply={multiply}
              options={options}
            />
          </Box>
        </GridFormField>
      ) : (
        <Flex flexDirection='column' gap={10}>
          {comment ? (
            <Flex flexDirection='column' gap={5}>
              <Label>{customLabel}</Label>
              <Typography fontSize={theme.fontSizes['14']}>{comment}</Typography>
            </Flex>
          ) : (
            <Label>{customLabel}</Label>
          )}
          <CheckboxGroup
            labelGap={labelGap}
            align={align}
            onChange={(value) => {
              form.setFieldValue(name, value);
            }}
            value={field.value}
            errorMessage={(meta.touched && meta.error) || ''}
            multiply={multiply}
            options={options}
          />
        </Flex>
      )
    }
  </Field>
);
